import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-list",
        name: "apps-monitoring-list",
        component: () => import("@/views/apps/monitoring/MonitoringList.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-add",
        name: "apps-monitoring-add",
        component: () => import("@/views/apps/monitoring/AddMonitoring.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-edit/:id",
        name: "apps-monitoring-edit",
        component: () => import("@/views/apps/monitoring/AddMonitoring.vue"),
      },
      {
        path: "/apps/monitoring/monitoring-show/:id",
        name: "apps-monitoring-show",
        component: () => import("@/views/apps/monitoring/MonitoringShow.vue"),
      },
      {
        path: "/apps/monitoring/point-list",
        name: "apps-monitoring-point-list",
        component: () =>
          import("@/views/apps/monitoring/AnalyseMonitoringList.vue"),
      },
      {
        path: "/apps/monitoring/indicateur-chart",
        name: "apps-monitoring-indicateur-chart",
        component: () => import("@/views/apps/monitoring/IndicateurCharts.vue"),
      },
      {
        path: "/apps/point/:id_pt/add-action",
        name: "apps-point-add-action-id_pt",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/add-action",
        name: "apps-point-add-action",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/edit-action-point/:id",
        name: "apps-point-edit-action-point",
        component: () => import("@/views/apps/monitoring/EditAction.vue"),
      },
      {
        path: "/apps/point/add-action-point/:id_pt",
        name: "apps-point-add-action-point",
        component: () => import("@/views/apps/monitoring/AddAction.vue"),
      },
      {
        path: "/apps/point/list-action/:id?",
        name: "apps-point-list-action",
        component: () => import("@/views/apps/monitoring/PlanActionList.vue"),
      },
      {
        path: "/apps/analyse/indicateur-chart",
        name: "apps-analyse-indicateur-chart",
        component: () => import("@/views/apps/analyse/IndicateurCharts.vue"),
        meta: {
          roles: [
            "Superadmin",
            "Management",
            "RSE Manager",
            "RSE Supervisor",
            "Others",
          ],
        },
      },
      {
        path: "/apps/analyse/analyse-env-list",
        name: "apps-analyse-analyse-env-list",
        component: () => import("@/views/apps/analyse/AnalyseEnvList.vue"),
      },
      {
        path: "/apps/analyse/add-analyse",
        name: "apps-analyse-add-analyse",
        component: () => import("@/views/apps/analyse/AddAnalyse.vue"),
      },
      {
        path: "/apps/analyse/add-action",
        name: "apps-analyse-add-action",
        component: () => import("@/views/apps/analyse/AddActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/add-action-analyse/:id",
        name: "apps-analyse-add-action-analyse",
        component: () => import("@/views/apps/analyse/AddActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/edit-action-analyse/:id",
        name: "apps-analyse-edit-action-analyse",
        component: () => import("@/views/apps/analyse/EditActionAnalyse.vue"),
      },
      {
        path: "/apps/analyse/list-action/:id?",
        name: "apps-analyse-list-action",
        component: () => import("@/views/apps/analyse/PlanActionList.vue"),
      },
      {
        path: "/apps/analyse/show-analyse/:id",
        name: "apps-analyse-show-analyse",
        component: () => import("@/views/apps/analyse/AnalyseEnvShow.vue"),
      },
      {
        path: "/apps/analyse/edit-analyse/:id",
        name: "apps-analyse-edit-analyse",
        component: () => import("@/views/apps/analyse/AddAnalyse.vue"),
      },
      {
        path: "/apps/reglementation/indicateur-chart",
        name: "apps-reglementation-indicateur-chart",
        component: () =>
          import("@/views/apps/reglementation/IndicateurCharts.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-list",
        name: "apps-reglementation-reglementation-list",
        component: () =>
          import("@/views/apps/reglementation/ReglementationList.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-add",
        name: "apps-reglementation-reglementation-add",
        component: () =>
          import("@/views/apps/reglementation/AddReglementation.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-show/:id",
        name: "apps-reglementation-reglementation-show",
        component: () =>
          import("@/views/apps/reglementation/ReglementationShow.vue"),
      },
      {
        path: "/apps/reglementation/reglementation-edit/:id",
        name: "apps-reglementation-reglementation-edit",
        component: () =>
          import("@/views/apps/reglementation/AddReglementation.vue"),
      },
      {
        path: "/apps/reglementation/:id_reg/add-action",
        name: "apps-reglementation-add-action-id_reg",
        component: () => import("@/views/apps/reglementation/AddAction.vue"),
      },
      {
        path: "/apps/reglementation/add-action",
        name: "apps-reglementation-add-action",
        component: () => import("@/views/apps/reglementation/AddAction.vue"),
      },
      {
        path: "/apps/reglementation/edit-action-reglementation/:id",
        name: "apps-reglementation-edit-action-reglementation",
        component: () => import("@/views/apps/reglementation/EditAction.vue"),
      },
      {
        path: "/apps/reglementation/list-action/:id?",
        name: "apps-reglementation-list-action",
        component: () =>
          import("@/views/apps/reglementation/PlanActionList.vue"),
      },
      {
        path: "/apps/settings/add-settings",
        name: "apps-settings-add-list",
        component: () => import("@/views/apps/settings/AddSettings.vue"),
      },
      {
        path: "/apps/settings/permission-settings",
        name: "apps-settings-permission-list",
        component: () => import("@/views/apps/settings/PermissionSettings.vue"),
      },
      {
        path: "/apps/account/profile",
        name: "apps-user-profile",
        component: () => import("@/views/apps/account/UserShow.vue"),
      },
      {
        path: "/apps/users/users-dashboard",
        name: "apps-users-dashboard",
        component: () => import("@/views/apps/users/UsersDashboard.vue"),
      },
      {
        path: "/apps/users/users-show",
        name: "apps-users-show",
        component: () => import("@/views/apps/users/UsersShow.vue"),
      },
      {
        path: "/apps/subscriptions/add-subscription",
        name: "apps-subscriptions-add-subscription",
        component: () =>
          import("@/views/apps/subscriptions/AddSubscription.vue"),
      },
      {
        path: "/apps/subscriptions/view-subscription",
        name: "apps-subscriptions-view-subscription",
        component: () =>
          import("@/views/apps/subscriptions/ViewSubscription.vue"),
      },
      {
        path: "/apps/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/apps/chat/DrawerChat.vue"),
      },
      {
        path: "/crafted/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () =>
          import("@/views/crafted/modals/general/InviteFriends.vue"),
      },
      {
        path: "/crafted/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/crafted/modals/general/ViewUsers.vue"),
      },
      {
        path: "/crafted/modals/general/upgrade-plan",
        name: "modals-general-upgrade-plan",
        component: () =>
          import("@/views/crafted/modals/general/UpgradePlan.vue"),
      },
      {
        path: "/crafted/modals/general/share-and-earn",
        name: "modals-general-share-and-earn",
        component: () =>
          import("@/views/crafted/modals/general/ShareAndEarn.vue"),
      },
      {
        path: "/crafted/modals/forms/new-target",
        name: "modals-forms-new-target",
        component: () => import("@/views/crafted/modals/forms/NewTarget.vue"),
      },
      {
        path: "/crafted/modals/forms/new-card",
        name: "modals-forms-new-card",
        component: () => import("@/views/crafted/modals/forms/NewCard.vue"),
      },
      {
        path: "/crafted/modals/forms/new-address",
        name: "modals-forms-new-address",
        component: () => import("@/views/crafted/modals/forms/NewAddress.vue"),
      },
      {
        path: "/crafted/modals/forms/create-api-key",
        name: "modals-forms-create-api-key",
        component: () =>
          import("@/views/crafted/modals/forms/CreateApiKey.vue"),
      },
      {
        path: "/crafted/modals/wizards/two-factor-auth",
        name: "modals-wizards-two-factor-auth",
        component: () =>
          import("@/views/crafted/modals/wizards/TwoFactorAuth.vue"),
      },
      {
        path: "/crafted/modals/wizards/create-app",
        name: "modals-wizards-create-app",
        component: () => import("@/views/crafted/modals/wizards/CreateApp.vue"),
      },
      {
        path: "/crafted/modals/wizards/create-account",
        name: "modals-wizards-create-account",
        component: () =>
          import("@/views/crafted/modals/wizards/CreateAccount.vue"),
      },
      {
        path: "/crafted/widgets/lists",
        name: "widgets-list",
        component: () => import("@/views/crafted/widgets/Lists.vue"),
      },
      {
        path: "/crafted/widgets/statistics",
        name: "widgets-statistics",
        component: () => import("@/views/crafted/widgets/Statistics.vue"),
      },
      {
        path: "/crafted/widgets/charts",
        name: "widgets-charts",
        component: () => import("@/views/crafted/widgets/Charts.vue"),
      },
      {
        path: "/crafted/widgets/mixed",
        name: "widgets-mixed",
        component: () => import("@/views/crafted/widgets/Mixed.vue"),
      },
      {
        path: "/crafted/widgets/tables",
        name: "widgets-tables",
        component: () => import("@/views/crafted/widgets/Tables.vue"),
      },
      {
        path: "/crafted/widgets/feeds",
        name: "widgets-feeds",
        component: () => import("@/views/crafted/widgets/Feeds.vue"),
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/views/Builder.vue"),
      },
      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/components/page-layouts/Profile.vue"),
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () =>
              import("@/views/crafted/pages/profile/Overview.vue"),
          },
          {
            path: "projects",
            name: "profile-projects",
            component: () =>
              import("@/views/crafted/pages/profile/Projects.vue"),
          },
          {
            path: "campaigns",
            name: "profile-campaigns",
            component: () =>
              import("@/views/crafted/pages/profile/Campaigns.vue"),
          },
          {
            path: "documents",
            name: "profile-documents",
            component: () =>
              import("@/views/crafted/pages/profile/Documents.vue"),
          },
          {
            path: "connections",
            name: "profile-connections",
            component: () =>
              import("@/views/crafted/pages/profile/Connections.vue"),
          },
          {
            path: "activity",
            name: "profile-activity",
            component: () =>
              import("@/views/crafted/pages/profile/Activity.vue"),
          },
        ],
      },
      {
        path: "/crafted/pages/wizards/horizontal",
        name: "horizontal-wizard",
        component: () => import("@/views/crafted/pages/wizards/Horizontal.vue"),
      },
      {
        path: "/crafted/pages/wizards/vertical",
        name: "vertical-wizard",
        component: () => import("@/views/crafted/pages/wizards/Vertical.vue"),
      },
      {
        path: "/crafted/account",
        name: "account",
        component: () => import("@/views/crafted/account/Account.vue"),
        children: [
          {
            path: "overview",
            name: "account-overview",
            component: () => import("@/views/crafted/account/Overview.vue"),
          },
          {
            path: "settings",
            name: "account-settings",
            component: () => import("@/views/crafted/account/Settings.vue"),
          },
        ],
      },
      {
        path: "/apps/customers/getting-started",
        name: "apps-customers-getting-started",
        component: () => import("@/views/apps/customers/GettingStarted.vue"),
      },
      {
        path: "/apps/customers/customers-listing",
        name: "apps-customers-listing",
        component: () => import("@/views/apps/customers/CustomersListing.vue"),
      },
      {
        path: "/apps/customers/customer-details",
        name: "apps-customers-details",
        component: () => import("@/views/apps/customers/CustomerDetails.vue"),
      },
      {
        path: "/apps/subscriptions/getting-started",
        name: "apps-subscriptions-getting-started",
        component: () =>
          import("@/views/apps/subscriptions/GettingStarted.vue"),
      },
      {
        path: "/apps/subscriptions/subscription-list",
        name: "apps-subscriptions-subscription-list",
        component: () =>
          import("@/views/apps/subscriptions/SubscriptionList.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },
  {
    path: "/multi-step-sign-up",
    name: "multi-step-sign-up",
    component: () =>
      import("@/views/crafted/authentication/MultiStepSignUp.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  setTimeout(() => {
    // const userRole = store.state.AuthModule.user.role.name;
    // const allowedRoles = (to.meta as { roles?: string[] }).roles; // Add type assertion for to.meta
    if (!store.state.AuthModule.isAuthenticated && to.name !== "sign-in") {
      next({ name: "sign-in" });
    } else {
      next();
    }
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
